import { Theme } from "../component/navigation/ThemeDropdown";

export default function BlogIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                {/* Outer Circle */}
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Main Rectangle */}
                <path
                    d="M9.52673 6.70227H18.6504C18.8947 6.70227 19.0962 6.90074 19.0962 7.14807V16.8519C19.0962 17.0962 18.8977 17.2977 18.6504 17.2977H9.52673C9.04123 17.2977 8.64734 16.9038 8.64734 16.4183V7.58166C8.64734 7.09616 9.04123 6.70227 9.52673 6.70227Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Left Rectangle */}
                <path
                    d="M5.34961 6.70227H7.76793C8.25343 6.70227 8.64732 7.09616 8.64732 7.58166V16.4152C8.64732 16.9007 8.25343 17.2946 7.76793 17.2946H5.34961C5.10534 17.2946 4.90381 17.0962 4.90381 16.8488V7.14807C4.90381 6.9038 5.10228 6.70227 5.34961 6.70227Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Top Line */}
                <path
                    d="M17.6641 8.76031H10.1893C9.9785 8.76031 9.80762 8.9312 9.80762 9.14199V9.14505C9.80762 9.35584 9.9785 9.52673 10.1893 9.52673H17.6641C17.8749 9.52673 18.0458 9.35584 18.0458 9.14505V9.14199C18.0458 8.9312 17.8749 8.76031 17.6641 8.76031Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Middle Line */}
                <path
                    d="M17.6641 10.4885H10.1893C9.9785 10.4885 9.80762 10.6594 9.80762 10.8702V10.8733C9.80762 11.0841 9.9785 11.2549 10.1893 11.2549H17.6641C17.8749 11.2549 18.0458 11.0841 18.0458 10.8733V10.8702C18.0458 10.6594 17.8749 10.4885 17.6641 10.4885Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Bottom Line */}
                <path
                    d="M13.545 12.0458H10.1893C9.9785 12.0458 9.80762 12.2167 9.80762 12.4275V12.4305C9.80762 12.6413 9.9785 12.8122 10.1893 12.8122H13.545C13.7558 12.8122 13.9267 12.6413 13.9267 12.4305V12.4275C13.9267 12.2167 13.7558 12.0458 13.545 12.0458Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
